import { ResumeTemplateTypes } from "./components/Resume/components/ResumeTemplates/ResumeTemplateTypes";

const config = {
  behavior: {
    useFixedNavBar: true,
  },

  templateType: ResumeTemplateTypes.STANDARD,

  name: "Diego Garcia",
  headline: "I love to build|solutions for companies",

  socialMediaUrl: {
    linkedin: "https://www.linkedin.com/in/devdiegogarcia",
    github: "https://github.com/diegomgarcia",
    instagram: "https://www.instagram.com/devdiegogarcia",
    x: "https://twitter.com/DevDiegoGarcia",
    facebook: "",
  },

  availabilityInfo: [
    {
      type: "text",
      content:
        "I am currently available for new opportunities. If you'd like to discuss any sort of opportunity, feel free to ",
    },
    { type: "link", content: "contact me", href: "mailto:%email%" },
  ],

  address: "Kingston, ON, Canada",
  email: "talkto@diegogarcia.ca",
  phone: "+1 (613) 532-4880",

  resumeData: {
    en: {
      name: "",
      headline:
        "Experienced Full-Stack Software Engineer focused on solutions for companies",
      address: "",
      email: "",
      phone: "",
      website: "diegogarcia.ca",

      socialMediaUrl: {
        linkedin: "",
        github: "",
        instagram: "",
        x: "",
        facebook: "",
      },

      skills: [
        {
          area: "Engineering",
          skills: [
            "System Architecture",
            "Microservice Architecture",
            "OOP",
            "Restful API",
          ],
        },
        {
          area: "Languages",
          skills: ["C#", "Dart", "GO", "Javascript", "Delphi"],
        },
        {
          area: "Backend Frameworks/Libraries",
          skills: [".NET", ".NET Core", "Entity Framework", "Dapr"],
        },
        {
          area: "Frontend Frameworks/Libraries",
          skills: [
            "Flutter",
            "Vue.Js",
            "React",
            "Razor Pages",
            "JQuery",
            "Javascript",
            "CSS",
            "Tailwind CSS",
            "Bootstrap",
            "JQuery UI",
            "Kendo UI",
          ],
        },
        {
          area: "Databases",
          skills: ["Microsoft SQL", "PostgreSQL"],
        },

        {
          area: "Version Control",
          skills: ["Git", "Azure Repos", "Mercurial", "SVN"],
        },
        {
          area: "Orchestration & Containerization",
          skills: ["Kubernetes", "Docker"],
        },
        {
          area: "CI/CD",
          skills: ["Azure Pipelines", "Github Actions", "Team City"],
        },
        {
          area: "Project Management",
          skills: ["Jira", "Azure Boards"],
        },
        {
          area: "Cloud & Hosting Services",
          skills: ["Azure Cloud", "Linode LDK"],
        },
      ],

      experiences: [
        {
          description: "Staff Software Developer",
          company: "IPG Photonics (Canada) Inc.",
          startDate: "Oct 2025",
          endDate: "Present",
          details:
            "Contract full-time role in an on-site environment in Kingston, Ontario. I contribute to maintaining and evolving a large, long-lived desktop codebase, collaborating across disciplines and focusing on reliability and correctness.\n" +
            "%bullet% Working in a legacy .NET Framework (WPF) application, maintaining existing features and refactoring legacy systems to follow better design patterns for improved overall software quality.\n" +
            "%bullet% Proposing optimizations on workflows and integrating CI/CD pipelines with legacy systems to streamline development processes.\n" +
            "%bullet% Writing proofs of concept (PoCs) to demonstrate new technologies and workflows, alongside conducting exploratory architecture research.\n" +
            "%bullet% Guiding and mentoring junior developers to cultivate engineering best practices and enhance team velocity.\n" +
            "%bullet% Contributing to C# and C++ codebases where required, following strict quality and review practices.\n" +
            "%bullet% Collaborating with senior engineers and stakeholders to align changes with broader system goals and deliver incremental, low-risk improvements.\n" +
            "%endbullet%\n" +
            "Note: Work details are intentionally high-level due to NDA constraints.",
        },
        {
          description: "Software Developer",
          company: "ClubRunner",
          startDate: "2024",
          endDate: "2025",
          hideHeader: false,
          details:
            "At ClubRunner, I contribute to the development and maintenance of both mobile and web applications, ensuring robust functionality and excellent user experience. My responsibilities include:\n" +
            "%bullet% Leading the migration of the mobile application from Xamarin to Flutter, ensuring feature parity, improved UI/UX, and better maintainability.\n" +
            "%bullet% Implementing push notifications and deep linking to enhance user engagement and streamline navigation within the mobile app.\n" +
            "%bullet% Designing and developing APIs using .NET Core to support seamless communication between the mobile and web platforms.\n" +
            "%bullet% Creating and refining Blazor components to build dynamic and interactive web interfaces.\n" +
            "%bullet% Developing and optimizing serverless processes using Azure Functions to handle specific application needs.\n" +
            "%endbullet%",
        },
        {
          description: "Software Developer",
          company: "ClubRunner (Continued)",
          startDate: "2024",
          endDate: "2025",
          hideHeader: true,
          details:
            "Additional contributions include:\n" +
            "%bullet% Working with SQL Server for database management, including optimizing queries and designing data structures.\n" +
            "%bullet% Setting up and maintaining CI/CD pipelines in Azure DevOps to ensure efficient deployment processes.\n" +
            "%bullet% Debugging and resolving complex issues across mobile and web platforms to ensure a smooth user experience.\n" +
            "%bullet% Collaborating with cross-functional teams to align development efforts with organizational goals.\n" +
            "%bullet% Using Jira for task tracking and sprint planning, ensuring alignment with project timelines and team objectives.\n" +
            "%endbullet%\n" +
            "Technologies and tools I work with daily include:\n" +
            "%bullet% Flutter and Dart for mobile development.\n" +
            "%bullet% C# and .NET Core for backend development.\n" +
            "%bullet% Blazor for web development.\n" +
            "%bullet% Azure Functions for serverless operations.\n" +
            "%bullet% SQL Server for database management.\n" +
            "%bullet% Azure DevOps for CI/CD pipeline management.\n" +
            "%bullet% Jira for task tracking and project management.\n" +
            "%bullet% Git for version control and collaboration.\n" +
            "%endbullet%\n" +
            "My goal is to deliver high-quality, scalable solutions while continuously improving processes and exploring new technologies to enhance ClubRunner's offerings.",
        },
        {
          description: "Software Engineer",
          company: "HQ Softwares",
          startDate: "2012",
          endDate: "2024",
          details:
            "At HQ Softwares, I was responsible for architecting and implementing software tailored to the customer’s needs. %br%This process involves:\n" +
            "%bullet% Guiding the sales team during proposal elaboration, understanding project details, and creating proofs of concept.\n" +
            "%bullet% Architecting systems, implementing the foundational version, writing unit tests, documenting it, and training the development team.\n" +
            "%bullet% Setting up tooling, infrastructure, and deploying the solution to the customer.\n" +
            "%endbullet%\n" +
            "Each project has unique requirements, and it's my duty to analyze and determine the best approach for each one.\n" +
            "%br%\n" +
            "On a daily basis, I work with:\n" +
            "%bullet% C# and .NET Core for backend development, using either a microservice or monolithic architecture with the MVC framework.\n" +
            "%bullet% Vue.js with Pinia/Vite or Razor Pages with jQuery UI + Bootstrap for frontend development.\n" +
            "%bullet% Microsoft SQL and PostgreSQL databases.\n" +
            "%bullet% RabbitMQ for messaging between microservices.\n" +
            "%bullet% Docker for deploying images to Kubernetes, using Azure Image Registry and AKS, or occasionally Linode LDK.\n" +
            "%bullet% Git for source code management.\n" +
            "%bullet% Azure DevOPS or Jira for task tracking via a scrum board and setting up CI/CD pipelines.\n" +
            "%endbullet%\n" +
            "My goal is to maintain high-quality standards by automating processes wherever possible, ensuring a positive customer experience, and continuously seeking optimizations to produce more efficient and reliable software.",
        },
        {
          description: "Software Development consultant",
          company: "TDS",
          startDate: "2010",
          endDate: "2012",
          details:
            "During my time at TDS, I was responsible for studying new technologies, formulating fresh content, documenting, and creating exercises to train developers from numerous software houses.%br%The classes I've mastered include:\n" +
            "%bullet% Software development with Delphi.\n" +
            "%bullet% Oriented Object Programming, Design Patterns and Test Driven Development.\n" +
            "%bullet% Component Creation.\n" +
            "%bullet% Multi-tier Architecture.\n" +
            "%endbullet%\n" +
            "My goal at TDS was not just to disseminate knowledge but also to continuously hone my own skills and ensure that every developer I trained was equipped with the most up-to-date practices in the industry.\n",

          //details: "During my time working for TDS, I was responsible to study new technologies, elaborate new content, document and create new exercises to training developers from several software house's located in Brazil. I have the opportunity to improve my skills thanks to the quantity of classes that I've prepared and mastered in TDS. Some of the classes that I've mastered includes, Software development with Delphi, Oriented Object Programming, Design Patterns, Test Driven Development, Component Creation, Multi tier Architecture and FinalBuilder automation.",
        },
        {
          description: "Software Developer",
          company: "Unit One",
          startDate: "2002",
          endDate: "2010",
          details:
            "At my previous position, I was responsible for designing, architecting frameworks, and developing custom software for clients as needed. %br% The technologies I primarily employed are:\n" +
            "%bullet% C# with ASP .Net framework utilizing the MVC pattern and SQL Server.\n" +
            "%bullet% Delphi with SQL Server for Desktop Backend applications.\n" +
            "%endbullet%\n" +
            "My principal goal was to diminish the intricacy of legacy software by creating a dedicated framework. This allowed for porting the legacy projects to newer technologies in significantly less time and enhanced the quality of the codebase. I employed techniques from design patterns and adhered to the SOLID and KISS principles.\n" +
            "%br%\n" +
            "The journey of framework development highlighted the need to enhance our database structures. This was done to boost its quality, making it more readable and maintainable. With this vision, I scripted software to migrate these structures automatically. The migration leveraged metadata and employed dictionary-based configurations.\n",
        },
      ],

      projects: [
        {
          name: "ERX",
          description:
            "Designed a multi-tenant ERP platform using a microservices architecture in .NET Core. Integrated Vue.js and Dart, with Dapr and RabbitMQ for microservices communication. Employed Kubernetes for deployment, secured with JWT and Ocelot API Gateway.",
        },
        {
          name: "Q21 Dental Care",
          description:
            "Led the architectural design of a multi-tenant ERP tailored for dental care companies. Implemented a schema-based structure, integrated a REST API with a distinct API gateway for internal and mobile app access, and introduced real-time chat capabilities.",
        },
        {
          name: "Flutter Talks",
          description:
            "Architected a system for a major Flutter event in Brazil, integrating a user-friendly subscription portal with a real-time QR code validation app. Implemented a secure REST API ensuring seamless backend-mobile interactions.",
        },
        {
          name: "Graphic Design Portal",
          description:
            "Developed a web portal for a company enabling clients to upload and manage graphic design projects. Facilitated tracking of execution, approval, and delivery processes.",
        },
        {
          name: "Intermap for Divicenter",
          description:
            "Crafted 'Intermap' for event attendees to locate stands on digital totem via an infrared interface. Featured a map with routing, zoom, and pan, adopted by giants like Reed Exhibition and GL Events in the pre-touchscreen era.",
        },
        {
          name: "MBM ERP System",
          description:
            "Engineered 'MBM', an ERP tailored for motoboy companies. Streamlined service order management, billing, provider payments, and customer notifications, while optimizing request sequencing.",
        },
      ],

      education: [
        {
          title: "MBA in Microservices Architecture",
          description: "",
          startDate: "",
          endDate: "",
        },
        {
          title: "Associate degree in Software Analyses and Development",
          description: "",
          startDate: "2015",
          endDate: "2017",
        },
      ],

      languages: [
        {
          name: "English",
          proficiency: "",
        },
        {
          name: "French",
          proficiency: "",
        },
        {
          name: "Portuguese",
          proficiency: "",
        },
      ],
    },
    pt: {
      name: "",
      headline:
        "Engenheiro de Software Full-Stack experiente focado em soluções para empresas",
      address: "",
      email: "",
      phone: "",
      website: "diegogarcia.ca",

      socialMediaUrl: {
        linkedin: "",
        github: "",
        instagram: "",
        x: "",
        facebook: "",
      },

      skills: [
        {
          area: "Engenharia",
          skills: [
            "Arquitetura de Sistemas",
            "Arquitetura de Microsserviços",
            "POO",
            "API Restful",
          ],
        },
        {
          area: "Linguagens",
          skills: ["C#", "Dart", "GO", "Javascript", "Delphi"],
        },
        {
          area: "Frameworks/Bibliotecas Backend",
          skills: [".NET", ".NET Core", "Entity Framework", "Dapr"],
        },
        {
          area: "Frameworks/Bibliotecas Frontend",
          skills: [
            "Flutter",
            "Vue.Js",
            "React",
            "Razor Pages",
            "JQuery",
            "Javascript",
            "CSS",
            "Tailwind CSS",
            "Bootstrap",
            "JQuery UI",
            "Kendo UI",
          ],
        },
        {
          area: "Bancos de Dados",
          skills: ["Microsoft SQL", "PostgreSQL"],
        },

        {
          area: "Controle de Versão",
          skills: ["Git", "Azure Repos", "Mercurial", "SVN"],
        },
        {
          area: "Orquestração e Conteinerização",
          skills: ["Kubernetes", "Docker"],
        },
        {
          area: "CI/CD",
          skills: ["Azure Pipelines", "Github Actions", "Team City"],
        },
        {
          area: "Gestão de Projetos",
          skills: ["Jira", "Azure Boards"],
        },
        {
          area: "Serviços de Nuvem e Hospedagem",
          skills: ["Azure Cloud", "Linode LDK"],
        },
      ],

      experiences: [
        {
          description: "Desenvolvedor de Software Staff",
          company: "IPG Photonics (Canadá) Inc.",
          startDate: "Out 2025",
          endDate: "Atual",
          details:
            "Cargo de contrato em tempo integral em ambiente presencial em Kingston, Ontário. Contribuo para a manutenção e evolução de uma base de código desktop extensa e longeva, colaborando entre disciplinas e focando em confiabilidade e correção.\n" +
            "%bullet% Trabalhando em uma aplicação legado .NET Framework (WPF), mantendo funcionalidades existentes e refatorando sistemas legados para seguir melhores padrões de design para melhorar a qualidade geral do software.\n" +
            "%bullet% Propondo otimizações em fluxos de trabalho e integrando pipelines de CI/CD com sistemas legados para agilizar os processos de desenvolvimento.\n" +
            "%bullet% Escrevendo provas de conceito (PoCs) para demonstrar novas tecnologias e fluxos de trabalho, além de realizar pesquisas exploratórias de arquitetura.\n" +
            "%bullet% Orientando e mentorando desenvolvedores juniores para cultivar as melhores práticas de engenharia e aumentar a velocidade da equipe.\n" +
            "%bullet% Contribuindo para bases de código C# e C++ onde necessário, seguindo práticas estritas de qualidade e revisão.\n" +
            "%bullet% Colaborando com engenheiros seniores e stakeholders para alinhar as mudanças com os objetivos mais amplos do sistema e entregar melhorias incrementais de baixo risco.\n" +
            "%endbullet%\n" +
            "Nota: Os detalhes do trabalho são intencionalmente de alto nível devido a restrições de NDA.",
        },
        {
          description: "Desenvolvedor de Software",
          company: "ClubRunner",
          startDate: "2024",
          endDate: "2025",
          hideHeader: false,
          details:
            "Na ClubRunner, contribuo para o desenvolvimento e manutenção de aplicações móveis e web, garantindo funcionalidade robusta e excelente experiência do usuário. Minhas responsabilidades incluem:\n" +
            "%bullet% Liderando a migração da aplicação móvel de Xamarin para Flutter, garantindo paridade de recursos, melhoria na UI/UX e melhor manutenibilidade.\n" +
            "%bullet% Implementando notificações push e deep linking para aumentar o engajamento do usuário e agilizar a navegação dentro do app móvel.\n" +
            "%bullet% Projetando e desenvolvendo APIs usando .NET Core para suportar a comunicação contínua entre as plataformas móvel e web.\n" +
            "%bullet% Criando e refinando componentes Blazor para construir interfaces web dinâmicas e interativas.\n" +
            "%bullet% Desenvolvendo e otimizando processos serverless usando Azure Functions para lidar com necessidades específicas da aplicação.\n" +
            "%endbullet%",
        },
        {
          description: "Desenvolvedor de Software",
          company: "ClubRunner (Continuação)",
          startDate: "2024",
          endDate: "2025",
          hideHeader: true,
          details:
            "Contribuições adicionais incluem:\n" +
            "%bullet% Trabalhando com SQL Server para gerenciamento de banco de dados, incluindo otimização de consultas e design de estruturas de dados.\n" +
            "%bullet% Configurando e mantendo pipelines de CI/CD no Azure DevOps para garantir processos de implantação eficientes.\n" +
            "%bullet% Depurando e resolvendo problemas complexos em plataformas móveis e web para garantir uma experiência de usuário tranquila.\n" +
            "%bullet% Colaborando com equipes multifuncionais para alinhar os esforços de desenvolvimento com os objetivos organizacionais.\n" +
            "%bullet% Usando Jira para acompanhamento de tarefas e planejamento de sprint, garantindo o alinhamento com os cronogramas do projeto e os objetivos da equipe.\n" +
            "%endbullet%\n" +
            "Tecnologias e ferramentas com as quais trabalho diariamente incluem:\n" +
            "%bullet% Flutter e Dart para desenvolvimento móvel.\n" +
            "%bullet% C# e .NET Core para desenvolvimento backend.\n" +
            "%bullet% Blazor para desenvolvimento web.\n" +
            "%bullet% Azure Functions para operações serverless.\n" +
            "%bullet% SQL Server para gerenciamento de banco de dados.\n" +
            "%bullet% Azure DevOps para gerenciamento de pipeline CI/CD.\n" +
            "%bullet% Jira para acompanhamento de tarefas e gestão de projetos.\n" +
            "%bullet% Git para controle de versão e colaboração.\n" +
            "%endbullet%\n" +
            "Meu objetivo é entregar soluções escaláveis e de alta qualidade, melhorando continuamente os processos e explorando novas tecnologias para aprimorar as ofertas da ClubRunner.",
        },
        {
          description: "Engenheiro de Software",
          company: "HQ Softwares",
          startDate: "2012",
          endDate: "2024",
          details:
            "Na HQ Softwares, fui responsável por arquitetar e implementar software adaptado às necessidades do cliente. %br%Este processo envolve:\n" +
            "%bullet% Orientar a equipe de vendas durante a elaboração de propostas, entendendo detalhes do projeto e criando provas de conceito.\n" +
            "%bullet% Arquitetar sistemas, implementar a versão fundamental, escrever testes unitários, documentar e treinar a equipe de desenvolvimento.\n" +
            "%bullet% Configurar ferramentas, infraestrutura e implantar a solução para o cliente.\n" +
            "%endbullet%\n" +
            "Cada projeto tem requisitos únicos, e é meu dever analisar e determinar a melhor abordagem para cada um.\n" +
            "%br%\n" +
            "No dia a dia, trabalho com:\n" +
            "%bullet% C# e .NET Core para desenvolvimento backend, utilizando arquitetura de microsserviços ou monolítica com o framework MVC.\n" +
            "%bullet% Vue.js com Pinia/Vite ou Razor Pages com jQuery UI + Bootstrap para desenvolvimento frontend.\n" +
            "%bullet% Bancos de dados Microsoft SQL e PostgreSQL.\n" +
            "%bullet% RabbitMQ para mensagens entre microsserviços.\n" +
            "%bullet% Docker para implantar imagens no Kubernetes, usando Azure Image Registry e AKS, ou ocasionalmente Linode LDK.\n" +
            "%bullet% Git para gerenciamento de código fonte.\n" +
            "%bullet% Azure DevOPS ou Jira para acompanhamento de tarefas via quadro scrum e configuração de pipelines CI/CD.\n" +
            "%endbullet%\n" +
            "Meu objetivo é manter padrões de alta qualidade, automatizando processos sempre que possível, garantindo uma experiência positiva para o cliente e buscando continuamente otimizações para produzir software mais eficiente e confiável.",
        },
        {
          description: "Consultor de Desenvolvimento de Software",
          company: "TDS",
          startDate: "2010",
          endDate: "2012",
          details:
            "Durante meu tempo na TDS, fui responsável por estudar novas tecnologias, formular novos conteúdos, documentar e criar exercícios para treinar desenvolvedores de inúmeras softhouses.%br%As aulas que ministrei incluem:\n" +
            "%bullet% Desenvolvimento de software com Delphi.\n" +
            "%bullet% Programação Orientada a Objetos, Padrões de Design e Desenvolvimento Orientado a Testes.\n" +
            "%bullet% Criação de Componentes.\n" +
            "%bullet% Arquitetura Multicamadas (Multi-tier).\n" +
            "%endbullet%\n" +
            "Meu objetivo na TDS não era apenas disseminar conhecimento, mas também aprimorar continuamente minhas próprias habilidades e garantir que cada desenvolvedor que eu treinasse estivesse equipado com as práticas mais atualizadas da indústria.\n",
        },
        {
          description: "Desenvolvedor de Software",
          company: "Unit One",
          startDate: "2002",
          endDate: "2010",
          details:
            "Em minha posição anterior, fui responsável por projetar, arquitetar frameworks e desenvolver software customizado para clientes conforme necessário. %br% As tecnologias que utilizei principalmente foram:\n" +
            "%bullet% C# com framework ASP .Net utilizando o padrão MVC e SQL Server.\n" +
            "%bullet% Delphi com SQL Server para aplicações Desktop Backend.\n" +
            "%endbullet%\n" +
            "Meu principal objetivo foi diminuir a complexidade do software legado através da criação de um framework dedicado. Isso permitiu portar os projetos legados para tecnologias mais novas em significativamente menos tempo e melhorou a qualidade da base de código. Empreguei técnicas de padrões de design e aderi aos princípios SOLID e KISS.\n" +
            "%br%\n" +
            "A jornada de desenvolvimento do framework destacou a necessidade de melhorar nossas estruturas de banco de dados. Isso foi feito para aumentar sua qualidade, tornando-as mais legíveis e fáceis de manter. Com essa visão, escrevi scripts para migrar essas estruturas automaticamente. A migração utilizou metadados e configurações baseadas em dicionários.\n",
        },
      ],

      projects: [
        {
          name: "ERX",
          description:
            "Projetou uma plataforma ERP multi-inquilino usando uma arquitetura de microsserviços em .NET Core. Integrou Vue.js e Dart, com Dapr e RabbitMQ para comunicação entre microsserviços. Empregou Kubernetes para implantação, protegido com JWT e Ocelot API Gateway.",
        },
        {
          name: "Q21 Dental Care",
          description:
            "Liderou o design arquitetural de um ERP multi-inquilino adaptado para empresas de odontologia. Implementou uma estrutura baseada em esquemas, integrou uma API REST com um API gateway distinto para acesso interno e via aplicativo móvel, e introduziu recursos de chat em tempo real.",
        },
        {
          name: "Flutter Talks",
          description:
            "Arquitetou um sistema para um grande evento de Flutter no Brasil, integrando um portal de inscrições amigável com um app de validação de QR code em tempo real. Implementou uma API REST segura garantindo interações contínuas entre backend e mobile.",
        },
        {
          name: "Portal de Design Gráfico",
          description:
            "Desenvolveu um portal web para uma empresa, permitindo que clientes enviem e gerenciem projetos de design gráfico. Facilitou o acompanhamento dos processos de execução, aprovação e entrega.",
        },
        {
          name: "Intermap para Divicenter",
          description:
            "Criou o 'Intermap' para que os participantes de eventos localizassem estandes em totens digitais via uma interface infravermelha. Apresentava um mapa com roteamento, zoom e pan, adotado por gigantes como Reed Exhibition e GL Events na era pré-touchscreen.",
        },
        {
          name: "MBM ERP System",
          description:
            "Desenvolveu o 'MBM', um ERP adaptado para empresas de motoboys. Agilizou a gestão de ordens de serviço, faturamento, pagamentos a fornecedores e notificações a clientes, ao mesmo tempo em que otimizou o sequenciamento de solicitações.",
        },
      ],

      education: [
        {
          title: "MBA em Arquitetura de Microsserviços",
          description: "",
          startDate: "",
          endDate: "",
        },
        {
          title: "Análise e Desenvolvimento de Sistemas",
          description: "",
          startDate: "2015",
          endDate: "2017",
        },
      ],

      languages: [
        {
          name: "Inglês",
          proficiency: "",
        },
        {
          name: "Francês",
          proficiency: "",
        },
        {
          name: "Português",
          proficiency: "",
        },
      ],
    },
    fr: {
      name: "",
      headline:
        "Ingénieur Logiciel Full-Stack expérimenté axé sur les solutions pour les entreprises",
      address: "",
      email: "",
      phone: "",
      website: "diegogarcia.ca",

      socialMediaUrl: {
        linkedin: "",
        github: "",
        instagram: "",
        x: "",
        facebook: "",
      },

      skills: [
        {
          area: "Ingénierie",
          skills: [
            "Architecture de Systèmes",
            "Architecture de Microservices",
            "POO (Programmation Orientée Objet)",
            "API Restful",
          ],
        },
        {
          area: "Langages",
          skills: ["C#", "Dart", "GO", "Javascript", "Delphi"],
        },
        {
          area: "Frameworks/Bibliothèques Backend",
          skills: [".NET", ".NET Core", "Entity Framework", "Dapr"],
        },
        {
          area: "Frameworks/Bibliotecas Frontend",
          skills: [
            "Flutter",
            "Vue.Js",
            "React",
            "Razor Pages",
            "JQuery",
            "Javascript",
            "CSS",
            "Tailwind CSS",
            "Bootstrap",
            "JQuery UI",
            "Kendo UI",
          ],
        },
        {
          area: "Bases de Données",
          skills: ["Microsoft SQL", "PostgreSQL"],
        },

        {
          area: "Contrôle de Version",
          skills: ["Git", "Azure Repos", "Mercurial", "SVN"],
        },
        {
          area: "Orchestration et Conteneurisation",
          skills: ["Kubernetes", "Docker"],
        },
        {
          area: "CI/CD",
          skills: ["Azure Pipelines", "Github Actions", "Team City"],
        },
        {
          area: "Gestion de Projets",
          skills: ["Jira", "Azure Boards"],
        },
        {
          area: "Services Cloud et Hébergement",
          skills: ["Azure Cloud", "Linode LDK"],
        },
      ],

      experiences: [
        {
          description: "Développeur Logiciel Staff",
          company: "IPG Photonics (Canada) Inc.",
          startDate: "Oct 2025",
          endDate: "Présent",
          details:
            "Contrat à temps plein dans um environnement sur site à Kingston, Ontario. Je contribue à la maintenance et à l'évolution d'une base de code desktop étendue et pérenne, en collaborant entre disciplines et en me concentrant sur la fiabilité et l'exactitude.\n" +
            "%bullet% Travail sur une application legacy .NET Framework (WPF), maintenance des fonctionnalités existantes et refactorisation des systèmes legacy pour suivre de meilleurs modèles de conception afin d'améliorer la qualité globale du logiciel.\n" +
            "%bullet% Proposition d'optimisations des flux de travail et intégration de pipelines CI/CD avec des systèmes legacy pour simplifier les processus de développement.\n" +
            "%bullet% Rédaction de preuves de concept (PoCs) pour démontrer de nouvelles technologies et flux de travail, ainsi que réalisation de recherches exploratoires sur l'architecture.\n" +
            "%bullet% Accompagnement et mentorat des développeurs juniors pour cultiver les meilleures pratiques d'ingénierie et augmenter la vélocité de l'équipe.\n" +
            "%bullet% Contribution aux bases de code C# et C++ selon les besoins, en suivant des pratiques de qualité et de révision strictes.\n" +
            "%bullet% Collaboration avec des ingénieurs seniors et des parties prenantes para aligner les changements avec les objectifs globaux du système et fournir des améliorations incrémentielles à faible risque.\n" +
            "%endbullet%\n" +
            "Note : Les détails du travail sont intentionnellement de haut niveau en raison des contraintes de NDA.",
        },
        {
          description: "Développeur Logiciel",
          company: "ClubRunner",
          startDate: "2024",
          endDate: "2025",
          hideHeader: false,
          details:
            "Chez ClubRunner, je contribue au développement et à la maintenance d'applications mobiles et web, garantissant une fonctionnalité robuste et une excellente expérience utilisateur. Mes responsabilités incluent :\n" +
            "%bullet% Direction de la migration de l'application mobile de Xamarin vers Flutter, garantissant la parité des fonctionnalités, l'amélioration de l'UI/UX et une meilleure maintenabilité.\n" +
            "%bullet% Mise en œuvre des notifications push et du deep linking pour accroître l'engagement des utilisateurs et simplifier la navigation au sein de l'application mobile.\n" +
            "%bullet% Conception et développement d'APIs en utilisant .NET Core pour soutenir une communication fluide entre les plateformes mobiles et web.\n" +
            "%bullet% Création et perfectionnement de composants Blazor pour construire des interfaces web dynamiques et interactives.\n" +
            "%bullet% Développement et optimisation de processus serverless avec Azure Functions pour répondre aux besoins spécifiques de l'application.\n" +
            "%endbullet%",
        },
        {
          description: "Développeur Logiciel",
          company: "ClubRunner (Suite)",
          startDate: "2024",
          endDate: "2025",
          hideHeader: true,
          details:
            "Les contributions supplémentaires incluent :\n" +
            "%bullet% Travail avec SQL Server pour la gestion de bases de données, y compris l'optimisation des requêtes et la conception de structures de données.\n" +
            "%bullet% Mise en place et maintenance de pipelines CI/CD dans Azure DevOps pour garantir des processus de déploiement efficaces.\n" +
            "%bullet% Débogage et résolution de problèmes complexes sur plateformes mobiles et web pour assurer une expérience utilisateur fluide.\n" +
            "%bullet% Collaboration avec des équipes transversales pour aligner les efforts de développement sur les objectifs organisationnels.\n" +
            "%bullet% Utilisation de Jira pour le suivi des tâches et la planification des sprints, garantissant l'alignement sur les délais du projet et les objectifs de l'équipe.\n" +
            "%endbullet%\n" +
            "Les technologies et outils que j'utilise quotidiennement incluent :\n" +
            "%bullet% Flutter et Dart pour le développement mobile.\n" +
            "%bullet% C# et .NET Core pour le développement backend.\n" +
            "%bullet% Blazor pour le développement web.\n" +
            "%bullet% Azure Functions pour les opérations serverless.\n" +
            "%bullet% SQL Server pour la gestion de bases de données.\n" +
            "%bullet% Azure DevOps pour la gestion de pipelines CI/CD.\n" +
            "%bullet% Jira pour le suivi des tâches et la gestion de projets.\n" +
            "%bullet% Git pour le contrôle de version et la collaboration.\n" +
            "%endbullet%\n" +
            "Mon objectif est de fournir des solutions de haute qualité et évolutives tout en améliorant continuellement les processus et en explorant de nouvelles technologies pour enrichir l'offre de ClubRunner.",
        },
        {
          description: "Ingénieur Logiciel",
          company: "HQ Softwares",
          startDate: "2012",
          endDate: "2024",
          details:
            "Chez HQ Softwares, j'étais responsable de l'architecture et de la mise en œuvre de logiciels adaptés aux besoins du client. %br%Ce processus comprenait :\n" +
            "%bullet% Orienter l'équipe commerciale lors de l'élaboration des propositions, comprendre les détails du projet et créer des preuves de concept.\n" +
            "%bullet% Architecturer les systèmes, implémenter la version initiale, rédiger des tests unitaires, documenter et former l'équipe de développement.\n" +
            "%bullet% Configurer l'outillage, l'infrastructure et déployer la solution chez le client.\n" +
            "%endbullet%\n" +
            "Chaque projet ayant des exigences uniques, mon rôle était d'analyser et de déterminer la meilleure approche pour chacun.\n" +
            "%br%\n" +
            "Au quotidien, je travaille avec :\n" +
            "%bullet% C# et .NET Core pour le développement backend, en utilisant soit une architecture de microservices ou monolithique avec le framework MVC.\n" +
            "%bullet% Vue.js avec Pinia/Vite ou Razor Pages avec jQuery UI + Bootstrap pour le développement frontend.\n" +
            "%bullet% Bases de données Microsoft SQL et PostgreSQL.\n" +
            "%bullet% RabbitMQ pour la messagerie entre microservices.\n" +
            "%bullet% Docker pour le déploiement d'images sur Kubernetes, en utilisant Azure Image Registry et AKS, ou occasionnellement Linode LDK.\n" +
            "%bullet% Git pour la gestion du code source.\n" +
            "%bullet% Azure DevOPS ou Jira pour le suivi des tâches via un tableau scrum et la mise en place de pipelines CI/CD.\n" +
            "%endbullet%\n" +
            "Mon objectif est de maintenir des normes de qualité élevées en automatisant les processus chaque fois que possible, en garantissant une expérience client positive et en recherchant continuellement des optimisations pour produire des logiciels plus efficaces et fiables.",
        },
        {
          description: "Consultant en Développement Logiciel",
          company: "TDS",
          startDate: "2010",
          endDate: "2012",
          details:
            "Pendant mon temps chez TDS, j'étais responsable de l'étude de nouvelles technologies, de la formulation de nouveaux contenus, de la documentation et de la création d'exercices pour former les développeurs de nombreuses sociétés de services informatiques.%br%Les cours que j'ai maîtrisés incluent :\n" +
            "%bullet% Développement logiciel avec Delphi.\n" +
            "%bullet% Programmation Orientée Objet, Design Patterns et Test Driven Development (TDD).\n" +
            "%bullet% Création de Composants.\n" +
            "%bullet% Architecture multi-niveaux (Multi-tier).\n" +
            "%endbullet%\n" +
            "Mon objectif chez TDS n'était pas seulement de diffuser des connaissances, mais aussi de perfectionner continuellement mes propres compétences et de m'assurer que chaque développeur que je formais était équipé des pratiques les plus récentes de l'industrie.\n",
        },
        {
          description: "Développeur Logiciel",
          company: "Unit One",
          startDate: "2002",
          endDate: "2010",
          details:
            "À mon poste précédent, j'étais responsable de la conception, de l'architecture de frameworks et du développement de logiciels personnalisés pour les clients selon leurs besoins. %br% Les technologies que j'utilisais principalement étaient :\n" +
            "%bullet% C# avec le framework ASP .Net en utilisant le modèle MVC et SQL Server.\n" +
            "%bullet% Delphi avec SQL Server pour les applications Desktop Backend.\n" +
            "%endbullet%\n" +
            "Mon objectif principal était de réduire la complexité des logiciels legacy en créant un framework dédié. Cela a permis de porter les projets legacy vers de nouvelles technologies en beaucoup moins de temps et d'améliorer la qualité de la base de code. J'ai employé des techniques de design patterns et respecté les principes SOLID et KISS.\n" +
            "%br%\n" +
            "Le parcours de développement du framework a souligné la nécessité d'améliorer nos structures de bases de données. Cela a été fait pour accroître sa qualité, la rendant plus lisible et maintenable. Avec cette vision, j'ai écrit des scripts pour migrer ces structures automatiquement. La migration exploitait les métadonnées et utilisait des configurations basadas sur des dictionnaires.\n",
        },
      ],

      projects: [
        {
          name: "ERX",
          description:
            "Conception d'une plateforme ERP multi-entités utilisant une architecture de microservices sous .NET Core. Intégration de Vue.js et Dart, avec Dapr et RabbitMQ pour la communication entre microservices. Utilisation de Kubernetes pour le déploiement, sécurisé par JWT et Ocelot API Gateway.",
        },
        {
          name: "Q21 Dental Care",
          description:
            "Direction de la conception architecturale d'un ERP multi-entités adapté aux cabinets dentaires. Mise en œuvre d'une structure basée sur des schémas, intégration d'une API REST avec un gateway API distinct pour l'accès interne et mobile, et introduction de capacités de chat en temps réel.",
        },
        {
          name: "Flutter Talks",
          description:
            "Architecture d'un système pour un événement Flutter majeur au Brésil, intégrant un portail d'inscription convivial avec une application de validation de QR codes en temps réel. Mise en œuvre d'une API REST sécurisée garantissant des interactions fluides entre le backend et le mobile.",
        },
        {
          name: "Portail de Design Graphique",
          description:
            "Développement d'un portail web pour une entreprise permettant aux clients de télécharger et gérer des projets de design graphique. Facilitation du suivi des processus d'exécution, d'approbation et de livraison.",
        },
        {
          name: "Intermap pour Divicenter",
          description:
            "Création de 'Intermap' pour permettre aux participants d'événements de localiser les stands sur un totem numérique via une interface infrarouge. Comprenait une carte avec routage, zoom et panoramique, adopté par des géants comme Reed Exhibition et GL Events à l'ère pré-écran tactile.",
        },
        {
          name: "MBM ERP System",
          description:
            "Conception de 'MBM', un ERP adapté aux entreprises de coursiers. Optimisation de la gestion des bons de commande, de la facturation, des paiements fournisseurs et des notifications clients, tout en optimisant le séquençage des demandes.",
        },
      ],

      education: [
        {
          title: "MBA en Architecture de Microservices",
          description: "",
          startDate: "",
          endDate: "",
        },
        {
          title: "Diplôme d'associé en Analyse et Développement de Logiciels",
          description: "",
          startDate: "2015",
          endDate: "2017",
        },
      ],

      languages: [
        {
          name: "Anglais",
          proficiency: "",
        },
        {
          name: "Français",
          proficiency: "",
        },
        {
          name: "Portugais",
          proficiency: "",
        },
      ],
    },
  },

  // Utility functions
  get firstName() {
    return this.name.split(" ")[0] || "";
  },

  get initials() {
    const names = this.name.trim().split(" ");
    const firstInitial = names[0] ? names[0][0] : "?";
    // Check if there is a last name, if not use the first name's initial if available
    const lastInitial = names[1] ? names[1][0] : firstInitial;
    return `${firstInitial}${lastInitial}`;
  },

  mapURL(url) {
    const baseURL = "https://maps.google.com/maps?";
    const query = encodeURIComponent(`${url}`);
    const params = [
      `width=100%`,
      `height=200`,
      `hl=en`,
      `q=${query}`,
      `ie=UTF8`,
      `t=`,
      `z=14`,
      `iwloc=B`,
      `output=embed`,
    ].join("&");
    return `${baseURL}${params}`;
  },

  addressURL(url) {
    const baseURL = "https://www.google.com/maps/place/";
    const query = encodeURIComponent(url);
    return `${baseURL}${query}`;
  },

  displayURL(url) {
    return url.replace("https://", "").replace("www.", "");
  },
};

export default config;
